module.exports = __webpack_public_path__ + "img/restaurant-service.7b23adc7.svg";